import { render, staticRenderFns } from "./tabloid.vue?vue&type=template&id=47119e9b"
import script from "./tabloid.vue?vue&type=script&lang=js"
export * from "./tabloid.vue?vue&type=script&lang=js"
import style0 from "./tabloid.vue?vue&type=style&index=0&id=47119e9b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports